export default __webpack_public_path__ + "static/media/project7.80fe9c75.png";